import { useTranslation } from 'react-i18next';
import { AgentTools, type ToolCall, type ToolCallSummary } from '@/features/types/tools';
import { ToolCallContainer } from '../../ToolCallContainer';
import { ToolCallContentBox } from '../../ToolCallContentBox';
import { useToolCallParser, ToolCallState } from '../../useToolCallParser';
import { ToolCallError } from '../../ToolCallError';

interface ObjectDiscoverTool {
  name: AgentTools.sf_object_discover;
}

export type ObjectDiscoverToolCall = ToolCall<ObjectDiscoverTool['name']>;

export type ObjectDiscoverToolCallSummary = ToolCallSummary<ObjectDiscoverTool['name']>;

interface ObjectDiscoverResult {
  [key: string]: unknown;
}

export function ObjectDiscoverToolCall({ toolCall }: { toolCall: ObjectDiscoverToolCallSummary }) {
  const { t } = useTranslation('prince');

  const { parsedResult, title } = useToolCallParser<ObjectDiscoverResult>(
    toolCall,
    ({ toolCallState }) => {
      switch (toolCallState) {
        case ToolCallState.Running:
          return t('toolCalls.sf_object_discover.title.whileRunning');
        case ToolCallState.Error:
          return t('toolCalls.sf_object_discover.title.errors');
        case ToolCallState.Success:
          return t('toolCalls.sf_object_discover.title.success');
      }
    }
  );

  const tabs = [
    {
      id: 'results',
      label: t('toolCalls.results'),
      showLoadingWhileRunning: true,
      content:
        !toolCall.isRunning && parsedResult ? (
          parsedResult.hasErrors ? (
            <ToolCallError parsedResult={parsedResult} />
          ) : (
            <ToolCallContentBox content={toolCall.results} />
          )
        ) : null,
    },
  ];

  return (
    <ToolCallContainer
      toolName={toolCall.name}
      title={title}
      isRunning={toolCall.isRunning}
      tabs={tabs}
    />
  );
}
